import { option } from 'fp-ts';
import { TaxRate } from '@mews-commander/data-access';
import { useLocalizeCurrency, useLocalizePercentage } from '@mews/framework';
import { getTaxRates } from '@mews-commander/core/legacy-globalization';
import { useCommanderSelector } from '@mews-commander/utils';

export const useLocalizeTaxRate = () => {
    const localizeCurrency = useLocalizeCurrency();
    const localizePercentage = useLocalizePercentage();

    const taxRates: Record<string, TaxRate> = useCommanderSelector(getTaxRates);

    return (taxRateCode: string) => {
        const taxRate = taxRates[taxRateCode];

        if (taxRate?.code && taxRate.strategy?.discriminator && taxRate.strategy.value?.value != null) {
            return option.some({
                label:
                    taxRate.strategy.discriminator === 'Flat'
                        ? // @ts-expect-error, incorrectly typed discriminated union
                          localizeCurrency(taxRate.strategy.value.value, taxRate.strategy.value.currencyCode)
                        : localizePercentage(taxRate.strategy.value.value, {
                              maximumFractionDigits: 2,
                          }),
                code: taxRate.code,
            });
        }
        return option.none;
    };
};
